import { createContext, useCallback, useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useFiltersProvider } from 'my-phr/context';
import { usePhrRouteMatch } from 'my-phr/layout/hooks';
import { PHR_ROUTES } from 'my-phr/const';
import { SEARCH_CONTEXTS } from './hooks';

const GlobalSearchContext = createContext();

export default function GlobalSearchProvider({ children }) {
  const { isTimeline, isDashboard } = usePhrRouteMatch();

  const [isActive, setIsActive] = useState(false);
  const history = useHistory();

  const onClose = useCallback(() => {
    setIsActive(false);
  }, []);

  const [, { setFilters }] = useFiltersProvider();

  const handleTimelineSearch = (query) => {
    setFilters((filters) => ({ ...filters, searchTerm: query }));
    if (!isTimeline) history.push(PHR_ROUTES.TIMELINE);
    onClose();
  };

  const handleLibrarySearch = (query) => {
    onClose();
    history.push({
      pathname: '/search/all',
      search: `query=${encodeURIComponent(String(query).trim())}`,
    });
  };

  const handleDashboardSearch = (query) => {
    setFilters((filters) => ({ ...filters, dashboardSearchTerm: query }));
    if (!isDashboard) history.push(PHR_ROUTES.DASHBOARD);
    onClose();
  };

  const onSubmit = ({ section, query }) => {
    if (section === SEARCH_CONTEXTS.timeline.id)
      return handleTimelineSearch(query);
    if (section === SEARCH_CONTEXTS.library.id)
      return handleLibrarySearch(query);
    if (section === SEARCH_CONTEXTS.dashboard.id)
      return handleDashboardSearch(query);

    // Search suggestion handling
    return handleLibrarySearch(section);
  };

  const value = {
    onClose,
    isActive,
    setIsActive,
    onSubmit,
  };

  return (
    <GlobalSearchContext.Provider value={value}>
      {children}
    </GlobalSearchContext.Provider>
  );
}

export function useGlobalSearch() {
  const context = useContext(GlobalSearchContext);
  if (!context) {
    throw new Error(
      'useGlobalSearch must be used within a GlobalSearchProvider'
    );
  }
  return context;
}
